<template>
  <div class="edit-view">
    <slot v-if="editable">
      <el-form-item>
        <el-input
          :value="data"
          @input="updateParent"
          :placeholder="placeholder"
        />
      </el-form-item>
    </slot>
    <span v-else>
      {{ data }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'EditView',
  props: [
    'value',
    'editable',
    'placeholder',
  ],
  computed: {
    data() {
      return this.value;
    },
  },
  methods: {
    updateParent(value) {
      this.$emit('input', value);
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
.edit-view .el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/steps/CollaboratorDetails/CollaboratorItem/EditView.vue